import React from 'react';

function Process({ steps }) {
  return (
    <section className="portfolioSection sectionReveal" id="process">
      <div className="portfolioSection__heading">
        <span className="portfolioEyebrow">Process</span>
        <h2>How I Work</h2>
        <p>
          A clear development workflow keeps the project focused from first conversation to launch and future improvements.
        </p>
      </div>

      <div className="portfolioProcess">
        {steps.map((step) => (
          <article className="portfolioProcessStep" key={step.step}>
            <span>{step.step}</span>
            <div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Process;
